
// import React, { useState, useEffect } from "react";
// import Slide from "@mui/material/Slide";
// import Typography from "@mui/material/Typography";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import { keyframes } from "@mui/system";
// import { useTheme } from "@mui/material/styles";

// // ✅ Icons
// import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
// import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";

// // 🟢 Bounce animation (from bottom)
// const bounceFromBottom = keyframes`
//   0% { transform: translateY(150%); opacity: 0; }
//   40% { transform: translateY(-20px); opacity: 1; }
//   65% { transform: translateY(8px); }
//   85% { transform: translateY(-4px); }
//   100% { transform: translateY(0); }
// `;

// function SocialPopup({
//   selectedItems = [],
//   onClearConfirm,
//   onContinue,
//   onBack,
//   onViewTemplate,
//   actionLabel = "Continue",
//   entityType = "profile",
// }) {
//   const hasItems = selectedItems.length > 0;
//   const theme = useTheme();
//   const [hasAnimatedIn, setHasAnimatedIn] = useState(false);

//   // ✅ Trigger animation once per show
//   useEffect(() => {
//     if (hasItems && !hasAnimatedIn) setHasAnimatedIn(true);
//     else if (!hasItems) setHasAnimatedIn(false);
//   }, [hasItems, hasAnimatedIn]);

//   const getLabel = () => {
//     let noun = "Profile";
//     if (entityType === "post") noun = "Post";
//     else if (entityType === "video") noun = "Video";

//     return `${selectedItems.length} ${noun}${selectedItems.length === 1 ? "" : "s"} Selected`;
//   };

//   const shouldShowLabel = actionLabel !== "Generate Snapshot" && entityType !== "snapshot";

//   return (
//     <Slide direction="up" in={hasItems} mountOnEnter unmountOnExit>
//       <MDBox
//         sx={{
//           position: "fixed",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "16px 24px",
//           zIndex: 1300,
//           borderTop: "4px solid #00A1A1", // 🟢 Teal border
//           backgroundColor: theme.functions.rgba("#dee2e6", 0.5), // 🟢 Frosted translucent background
//           backdropFilter: `saturate(200%) blur(30px)`,
//           boxShadow: "0 -3px 12px rgba(0,0,0,0.15)",
//           animation: hasAnimatedIn
//             ? `${bounceFromBottom} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1)`
//             : "none", // 🟢 Bounce on appear
//         }}
//       >
//         {/* Left label */}
//         {shouldShowLabel ? (
//           <Typography variant="h6" sx={{ fontWeight: 600 }}>
//             {getLabel()}
//           </Typography>
//         ) : (
//           <MDBox sx={{ width: "200px" }} /> // maintain spacing
//         )}

//         {/* Right Buttons */}
//         <MDBox
//           display="flex"
//           gap={2}
//           sx={{
//             mr: { xs: 2, sm: 6, md: 8 },
//             flexWrap: { xs: "wrap", sm: "nowrap" },
//             justifyContent: "flex-end",
//           }}
//         >
//           {/* Continue / Primary Action */}
//           <MDButton
//             variant="contained"
//             color="accent"
//             onClick={onContinue}
//             startIcon={<PlayArrowOutlinedIcon />}
//             sx={{
//               whiteSpace: "nowrap",
//               minWidth: { xs: "100%", sm: "180px" },
//               fontWeight: 500,
//             }}
//           >
//             {actionLabel}
//           </MDButton>

//           {/* View Template (only for snapshot) */}
//           {entityType === "snapshot" && (
//             <MDButton
//               variant="outlined"
//               color="info"
//               onClick={onViewTemplate}
//               startIcon={<VisibilityOutlinedIcon />}
//               sx={{
//                 whiteSpace: "nowrap",
//                 minWidth: { xs: "100%", sm: "170px" },
//               }}
//             >
//               View Template
//             </MDButton>
//           )}

//           {/* Clear Selection */}
//           {onClearConfirm && (
//             <MDButton
//               variant="outlined"
//               color="error"
//               onClick={onClearConfirm}
//               startIcon={<ClearOutlinedIcon />}
//               sx={{
//                 whiteSpace: "nowrap",
//                 minWidth: { xs: "100%", sm: "130px" },
//               }}
//             >
//               Clear
//             </MDButton>
//           )}

//           {/* Back Button */}
//           {onBack && (
//             <MDButton
//               variant="outlined"
//               color="dark"
//               onClick={onBack}
//               startIcon={<ArrowBackOutlinedIcon />}
//               sx={{
//                 whiteSpace: "nowrap",
//                 minWidth: { xs: "100%", sm: "130px" },
//               }}
//             >
//               Back
//             </MDButton>
//           )}
//         </MDBox>
//       </MDBox>
//     </Slide>
//   );
// }

// export default SocialPopup;

// #################################################################
import React, { useState, useEffect } from "react";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { keyframes } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import LiveDemoRestriction from "layouts/components/Upgrade/liveDemo"; // [NEW]
import GuidanceBubble from "layouts/guidance/components/GuidanceBubble"; // [NEW]
import { usePermissions } from "context"; // [NEW]
import UpgradePopup from "layouts/components/Upgrade"; // [NEW]

// UPDATED: Added translateX(-50%) to all keyframes for stable centering during and after animation.
const bounceFromBottom = keyframes`
  0% { transform: translateX(-50%) translateY(150%); opacity: 0; }
  40% { transform: translateX(-50%) translateY(-20px); opacity: 1; }
  65% { transform: translateX(-50%) translateY(8px); }
  85% { transform: translateX(-50%) translateY(-4px); }
  100% { transform: translateX(-50%) translateY(0); }
`;

function SocialPopup({
  selectedItems = [],
  onClearConfirm,
  onContinue,
  onBack,
  onViewTemplate,
  actionLabel = "Continue",
  entityType = "profile",
  isEditing = false,
  isSaving = false, // 🟢 NEW PROP
  demoHighlight = false,
  allowDemoAction = false,
}) {
  const hasItems = selectedItems.length > 0;
  const theme = useTheme();
  const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
  const [showDemoPopup, setShowDemoPopup] = useState(false);

  const [showRBAC, setShowRBAC] = useState(false);
  const { hasPermission, requiredRoles } = usePermissions();

  // [NEW] Live Demo Check
  const handleContinue = () => {
    // [NEW] RBAC Check
    if (!hasPermission("snapshots:manage")) {
      setShowRBAC(true);
      return;
    }

    const isDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";

    if (isDemo && entityType === "snapshot") {
      const selectedType = selectedItems[0];
      if (selectedType === "market") {
        onContinue();
        return;
      }
      setShowDemoPopup(true);
      return;
    }

    if (isDemo) {
      if (allowDemoAction) {
        onContinue();
        return;
      }
      setShowDemoPopup(true);
      return;
    }

    onContinue();
  };

  useEffect(() => {
    if (hasItems && !hasAnimatedIn) setHasAnimatedIn(true);
    else if (!hasItems) setHasAnimatedIn(false);
  }, [hasItems, hasAnimatedIn]);

  const toInitCap = (val) => {
    if (!val) return "";
    const str = Array.isArray(val) ? val[0] : String(val);
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const getLabel = () => {
    let noun = "Profile";
    if (entityType === "post") noun = "Post";
    else if (entityType === "video") noun = "Video";
    else if (entityType === "snapshot") noun = "Snapshot";

    if (entityType === "snapshot" && selectedItems.length > 0) {
      return `${toInitCap(selectedItems)} Snapshot Selected`;
    }
    return `${selectedItems.length} ${noun}${selectedItems.length === 1 ? "" : "s"} Selected`;
  };

  const shouldShowLabel = true;

  // 🟢 Dynamically adjust label for snapshots
  const finalActionLabel = isSaving ? "SAVING..." : actionLabel;

  return (
    <>
      <Slide direction="up" in={hasItems} mountOnEnter unmountOnExit>
        <MDBox
          sx={{
            position: "fixed",
            bottom: 10,
            left: "50%",
            transform: "translateX(-50%)",
            width: "95%",
            maxWidth: "800px",
            display: "flex",
            justifyContent: shouldShowLabel ? "space-between" : "center",
            alignItems: "center",
            padding: "12px 24px",
            borderRadius: "12px",
            zIndex: 1300,
            border: "2px solid #00A1A1",
            backgroundColor: theme.functions.rgba("#000", 0.5),
            backdropFilter: `saturate(200%) blur(30px)`,
            boxShadow: "0 -3px 12px rgba(0,0,0,0.15)",
            animation: hasAnimatedIn
              ? `${bounceFromBottom} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards`
              : "none",
          }}
        >
          {/* Left label */}
          {shouldShowLabel ? (
            <Typography variant="h6" color="#fff" sx={{ fontWeight: 600 }}>
              {getLabel()}
            </Typography>
          ) : null}

          {/* Right Buttons */}
          <MDBox
            display="flex"
            gap={2}
            sx={{
              flexWrap: { xs: "wrap", sm: "nowrap" },
              justifyContent: 'center',
            }}
          >
            {/* Continue / Primary Action */}
            <MDBox position="relative">
              {demoHighlight && (
                <GuidanceBubble
                  visible={true}
                  message={
                    (actionLabel && actionLabel.toLowerCase().includes("generate"))
                      ? "Click Save Snapshot"
                      : "Click Continue"
                  }
                />
              )}
              <MDButton
                variant="contained"
                color="accent"
                onClick={handleContinue}
                disabled={isSaving}
                startIcon={!isSaving && <PlayArrowOutlinedIcon />}
                sx={{
                  whiteSpace: "nowrap",
                  minWidth: { xs: "100%", sm: "180px" },
                  fontWeight: 500,
                  transition: "transform 0.3s ease",
                  transform: demoHighlight ? "scale(1.1)" : "none",
                  zIndex: demoHighlight ? 1400 : "auto",
                  boxShadow: demoHighlight ? "0 0 15px rgba(255, 179, 71, 0.6)" : undefined
                }}
              >
                {isSaving && (
                  <CircularProgress
                    size={20}
                    color="inherit"
                    sx={{ mr: 1, color: "#fff" }}
                  />
                )}
                {finalActionLabel}
              </MDButton>
            </MDBox>

            {/* View Template (only for snapshot) */}
            {entityType === "snapshot" && (
              <MDButton
                variant="contained"
                color="info"
                onClick={onViewTemplate}
                startIcon={<VisibilityOutlinedIcon />}
                sx={{
                  whiteSpace: "nowrap",
                  minWidth: { xs: "100%", sm: "170px" },
                }}
              >
                View Template
              </MDButton>
            )}

            {/* Clear Selection */}
            {onClearConfirm && (
              <MDButton
                variant="contained"
                color="error"
                onClick={onClearConfirm}
                startIcon={<ClearOutlinedIcon />}
                sx={{
                  whiteSpace: "nowrap",
                  minWidth: { xs: "100%", sm: "130px" },
                }}
              >
                Clear
              </MDButton>
            )}

            {/* Back Button */}
            {onBack && (
              <MDButton
                variant="outlined"
                onClick={onBack}
                startIcon={<ArrowBackOutlinedIcon />}
                sx={{
                  whiteSpace: "nowrap",
                  minWidth: { xs: "100%", sm: "130px" },
                  color: "#000 !important",
                  borderColor: "#000 !important",
                  "&:hover": {
                    borderColor: "#000",
                    backgroundColor: "rgba(0, 0, 0, 0.0)", // subtle hover effect
                  },
                }}
              >
                Back
              </MDButton>
            )}
          </MDBox>
        </MDBox>
      </Slide>
      {/* [NEW] Live Demo Restriction Popup */}
      <LiveDemoRestriction
        open={showDemoPopup}
        onClose={() => setShowDemoPopup(false)}
        featureName="Generating Brand Snapshot"
        helpText="Please try Market Snapshot or use the view template button to download a sample snapshot."
      />

      {/* [NEW] RBAC Restriction Popup */}
      <UpgradePopup
        open={showRBAC}
        onClose={() => setShowRBAC(false)}
        type="rbac"
        featureName="Generating Snapshots"
        roleRequired={requiredRoles["snapshots:manage"] || "Manager"}
      />
    </>
  );
}

export default SocialPopup;

// // #########################################################
// // Appear Right

// import React, { useState, useEffect } from "react";
// import Slide from "@mui/material/Slide";
// import Typography from "@mui/material/Typography";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import { keyframes } from "@mui/system";

// // ✅ Icons
// import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
// import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
// import { useTheme } from "@mui/material/styles";

// // 🎞️ Bounce animation (same as right-side popup)
// const bounceFromRight = keyframes`
//   0% { transform: translateX(150%); opacity: 0; }
//   40% { transform: translateX(-20px); opacity: 1; }
//   65% { transform: translateX(8px); }
//   85% { transform: translateX(-4px); }
//   100% { transform: translateX(0); }
// `;

// function SocialPopup({
//   selectedItems = [],
//   onClearConfirm,
//   onContinue,
//   onBack,
//   onViewTemplate,
//   actionLabel = "Continue",
//   entityType = "profile",
// }) {
//   const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
//   const hasItems = selectedItems.length > 0;
//   const theme = useTheme();

//   // ✅ Ensure bounce happens only once per appearance
//   useEffect(() => {
//     if (hasItems && !hasAnimatedIn) {
//       setHasAnimatedIn(true);
//     } else if (!hasItems) {
//       setHasAnimatedIn(false);
//     }
//   }, [hasItems, hasAnimatedIn]);

//   const getLabel = () => {
//     let noun = "Profile";
//     if (entityType === "post") noun = "Post";
//     else if (entityType === "video") noun = "Video";

//     return `${selectedItems.length} ${noun}${selectedItems.length === 1 ? "" : "s"} Selected`;
//   };

//   const shouldShowLabel = actionLabel !== "Generate Snapshot" && entityType !== "snapshot";

//   return (
//     <Slide
//       direction="left"
//       in={hasItems}
//       mountOnEnter
//       unmountOnExit
//       timeout={{ enter: 300, exit: 200 }}
//     >
//       <MDBox
//         bgColor="#f7f7f7"
//         sx={{
//           position: "fixed",
//           top: "50%",
//           right: "24px",
//           transform: "translateY(-50%)",
//           // width: "320px",
//           width: "255px",
//           boxShadow: "-3px 3px 12px rgba(0,0,0,0.15)",
//           borderRadius: "16px 0 0 16px",
//           borderLeft: "4px solid #00A1A1",
//           // backgroundColor: "#ced4da",
//             backgroundColor: theme.functions.rgba("#dee2e6", 0.80),
//             backdropFilter: `saturate(200%) blur(30px)`,
//           padding: "24px",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "space-between",
//           zIndex: 1300,
//           animation: hasAnimatedIn
//             ? `${bounceFromRight} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1)`
//             : "none",
//         }}
//       >
//         {/* Header */}
//         {shouldShowLabel ? (
//           <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
//             {getLabel()}
//           </Typography>
//         ) : (
//           <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
//             Actions
//           </Typography>
//         )}

//         {/* Main Buttons */}
//         <MDBox display="flex" flexDirection="column" gap={1.5} mt="auto">
//           {/* Continue */}
//           <MDButton
//             variant="contained"
//             color="accent"
//             fullWidth
//             onClick={onContinue}
//             startIcon={<PlayArrowOutlinedIcon />}
//           >
//             {actionLabel}
//           </MDButton>

//           {/* View Template (only for snapshot) */}
//           {entityType === "snapshot" && (
//             <MDButton
//               variant="outlined"
//               color="info"
//               fullWidth
//               onClick={onViewTemplate}
//               startIcon={<VisibilityOutlinedIcon />}
//             >
//               View Template
//             </MDButton>
//           )}

//           {/* Clear Selection */}
//           {onClearConfirm && (
//             <MDButton
//               variant="outlined"
//               color="error"
//               fullWidth
//               onClick={onClearConfirm}
//               startIcon={<ClearOutlinedIcon />}
//             >
//               Clear
//             </MDButton>
//           )}

//           {/* Back Button */}
//           {onBack && (
//             <MDButton
//               variant="outlined"
//               color="dark"
//               fullWidth
//               onClick={onBack}
//               startIcon={<ArrowBackOutlinedIcon />}
//             >
//               Back
//             </MDButton>
//           )}
//         </MDBox>
//       </MDBox>
//     </Slide>
//   );
// }

// export default SocialPopup;
